import React, { memo } from 'react';
import { createUseStyle } from '@redlink/assets/styles';
import { Button } from '@redlink/components/molecules';
import { DataGridColumn } from './dataGridColumn';

export const DataGridTextLinkColumn = memo(
  ({ renderColumn, style, onPress, ...rest }) => {
    const { styles } = useStyle();
    return (
      <DataGridColumn
        {...rest}
        renderColumn={(item, value) => (
          <Button
            onPress={() => onPress?.(item)}
            variant="link"
            title={value}
            textStyle={[styles.simpleText, style]}
          />
        )}
      />
    );
  }
);

const useStyle = createUseStyle(({ colors, size }) => ({
  simpleText: {
    fontSize: 14,
  },
}));
